import { HStack, Button, Text } from 'native-base';
import { theme } from '@breakroom-nx/assets';

export interface CustomCheckboxProps {
  title: string;
  checked: boolean;
  onCheckboxSelect: () => void;
  startIcon?: JSX.Element | JSX.Element[];
  otherSelected?: boolean;
}

export const CustomCheckbox = ({
  title,
  checked,
  onCheckboxSelect,
  startIcon = undefined,
  otherSelected = false,
}: CustomCheckboxProps) => {
  // Darker background and text if another is selected and this is not checked
  const uncheckedBg = theme.colors.surface[200];
  const uncheckedText =
    otherSelected && !checked
      ? theme.colors.surface[500]
      : theme.colors.surface[600];

  return (
    <Button
      _hover={{
        backgroundColor: checked ? theme.colors.primary[100] : uncheckedBg,
      }}
      startIcon={startIcon ?? undefined}
      onPress={onCheckboxSelect}
      _pressed={{
        backgroundColor: checked ? theme.colors.primary[100] : uncheckedBg,
      }}
      rounded={'full'}
      borderRadius={'full'}
      borderColor={checked ? theme.colors.primary[400] : uncheckedBg}
      borderWidth={1.5}
      mb={3}
      bg={checked ? theme.colors.primary[100] : uncheckedBg}
    >
      <HStack px={1} py={0} space={1} rounded={'full'} alignItems={'center'}>
        <Text
          color={checked ? theme.colors.primary[400] : uncheckedText}
          fontWeight={checked ? 600 : 400}
          fontSize={15}
        >
          {title}
        </Text>
      </HStack>
    </Button>
  );
};
